import {CaptureConsole} from '@sentry/integrations';
import {Replay, init} from '@sentry/react';

import type {SentryConfig} from 'src/openapi/admin/models/SentryConfig';

export const initSentry = () => {
    fetch('/web-api/sentry-config')
        .then(e => e.json())
        .then((e: SentryConfig) => {
            if (e?.sentryDsn) {
                init({
                    dsn: e.sentryDsn,
                    release: PB_ADMIN_APP_VERSION,
                    replaysOnErrorSampleRate: 0.1,
                    attachStacktrace: true,
                    integrations: [
                        new Replay(),
                        new CaptureConsole({levels: ['error']}),
                    ],
                    tracesSampleRate: 1,
                });
            }
        })
        .catch((reason: string) => {
            // eslint-disable-next-line no-console
            console.log(reason);
        });
};
